var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "11", height: "16", viewBox: "0 0 11 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.78 5.45l2.77-2.29 2.57 2.3v5.75l-2.64 2.3-2.7-2.3V5.45z", fill: "#E2C354", stroke: "#E2C354", strokeWidth: ".14" }),
    React.createElement("path", { d: "M5.48.67L.9 4.48l1.88.97 2.7-2.29V.66z", fill: "#fff", stroke: "#fff", strokeWidth: ".14" }),
    React.createElement("path", { d: "M5.48.67l4.58 3.81-1.87.97-2.7-2.29V.66z", fill: "#DBB429", stroke: "#DBB429", strokeWidth: ".14" }),
    React.createElement("path", { d: "M5.48 16L.9 12.18l1.88-.97 2.7 2.3V16z", fill: "#9B801D", stroke: "#9B801D", strokeWidth: ".14" }),
    React.createElement("path", { d: "M5.48 16l4.58-3.82-1.87-.97-2.7 2.3V16z", fill: "#786317", stroke: "#786317", strokeWidth: ".14" }),
    React.createElement("path", { d: "M.83 12.11V4.48l1.95.97v5.7l-1.95.96z", fill: "#F4E8BD" }),
    React.createElement("path", { d: "M10.06 12.18V4.55l-1.94.97v5.7l1.94.96z", fill: "#DBB429", stroke: "#DBB429", strokeWidth: ".14" })
  );
});